// A plan picked on the website before signing up (?plan=essentials&cadence=monthly).
// It is saved on the invite page and consumed once by the paywall, which sends
// the new company straight to checkout for it.
const STORAGE_KEY = 'myflow:plan-preset:v1';
const PLANS = ['basic', 'essentials', 'pro'];
const CADENCES = ['monthly', 'yearly'];

export function browserStorage() {
    try {
        return globalThis.localStorage ?? null;
    } catch {
        return null;
    }
}

function normalize(plan, cadence) {
    if (!PLANS.includes(plan)) {
        return null;
    }

    return { plan, cadence: CADENCES.includes(cadence) ? cadence : null };
}

// Reads ?plan=…&cadence=… from a query string; null without a valid plan.
export function planPresetFromQuery(search) {
    const params = new URLSearchParams(search);

    return normalize(params.get('plan'), params.get('cadence'));
}

// Saves the plan from the query string; a visit without a valid plan leaves
// any earlier preset untouched.
export function savePlanPreset(storage, search) {
    const preset = planPresetFromQuery(search);

    if (preset === null) {
        return null;
    }

    try {
        storage?.setItem(STORAGE_KEY, JSON.stringify(preset));
    } catch {
        // Storage can be full or blocked; the paywall then shows every plan.
    }

    return preset;
}

// Returns the saved preset and removes it, so returning from a cancelled
// checkout shows the plans instead of starting checkout again.
export function takePlanPreset(storage) {
    try {
        const raw = storage?.getItem(STORAGE_KEY) ?? null;
        if (raw === null) {
            return null;
        }

        storage.removeItem(STORAGE_KEY);
        const saved = JSON.parse(raw);

        return normalize(saved?.plan, saved?.cadence);
    } catch {
        return null;
    }
}
